import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VersionSelectorComponent } from './version-selector.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  declarations: [VersionSelectorComponent],
  exports: [VersionSelectorComponent],
})
export class VersionSelectorModule {}
